import React from "react";

const TimeInput = React.forwardRef(({ value, onClick, onChange , className, ...rest}, ref) => {
  const handleKeyDown = (e) => {
    const allowedKeys = [
      "Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", ":", "Home", "End"
    ];
    const isNumber = /^[0-9]$/.test(e.key);
    const isAllowed = allowedKeys.includes(e.key);

    // Prevent entering more than 5 characters
    if (
      !isNumber &&
      !allowedKeys.includes(e.key)
    ) {
      e.preventDefault();
    }

    // Prevent typing beyond HH:mm format length
    if (
      !allowedKeys.includes(e.key) &&
      value?.length >= 5
    ) {
      e.preventDefault();
    }
  };

  const handleChange = (e) => {
    const val = e.target.value;

    // Allow only digits and colon
    if (/^[0-9:]*$/.test(val) && val.length <= 5) {
      onChange(e);
    }
  };

  return (
    <input
      ref={ref}
      type="text"
      className={`form-control ${className}`}
      
      onClick={onClick}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      value={value}
      placeholder="HH:mm"
      {...rest}
    />
  );
});

export default TimeInput;
